import { render, staticRenderFns } from "./chairmans.vue?vue&type=template&id=544904ef&scoped=true&"
import script from "./chairmans.vue?vue&type=script&lang=js&"
export * from "./chairmans.vue?vue&type=script&lang=js&"
import style0 from "./chairmans.vue?vue&type=style&index=0&id=544904ef&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544904ef",
  null
  
)

export default component.exports